<template>
  <div class="pageContent">
    <!-- <div class="dataTitle">
      <van-icon
        class="hospiyalsArrowLeft"
        style="top: 16px;"
        name="arrow-left"
        @click="onBack"
        v-if="forwardingReport"
      />
      <div class="title">
        <div class="content" @click="toReport" v-if="examReport">检查报告</div>
        <div class="line" v-if="examReport">|</div>
    <div class="content action">数字影像</div>-->
    <!-- <div class="line" v-if="forwardingReport&&examId">|</div>
    <div class="content" @click="toForwarding" v-if="forwardingReport&&examId">转发报告</div>-->
    <!-- </div>
    </div>-->
    <div class="portraitContent">
      <iframe :src="src" frameborder="0"></iframe>
    </div>
  </div>
</template>
<script>
import { getReportByCode } from "@/api/report";
import Storage from "@/tools/storage";
export default {
  name: "portrait",
  data() {
    return {
      xxx: Storage.get("makeReportLinkName"),
      src: "",
      code: "",
      examReport: true,
      forwardingReport: true,
      examId: true,
      isAnonymous: 0,
      isEncrypt: 0
    };
  },
  methods: {
    toReport() {
      this.$router.push({ path: "/reportInfoOuter/report" });
    },
    onBack() {
      // this.$router.push({ path: "/filmQuery" });
      this.$router.go(-1);
    },
    toForwarding() {
      this.$router.push({ path: "/reportInfoOuter/forwarding" });
    }
    // async cencelMontmorillonite() {
    //   let params = { id: Storage.get('makeReportLinkId'), code: this.code }
    //   let res = await getReportByCode(params)
    //   if (res) {
    //     if (res.study_id) {
    //       Storage.set('studyId', res.study_id)
    //     } else {
    //       Storage.set('studyId', res[0].study_id)
    //     }
    //     this.Montmorillonite = false
    //   }
    // }
  },
  created() {
    let url = window.location.href;
    this.isEncrypt = this.$route.query.isEncrypt
    this.isAnonymous = this.$route.query.isAnonymous
    console.log(decodeURI(url));
    if (url.indexOf("study_id=") != -1) {
      let str = url.match(/id=(\S*)&openid/)[1];
      Storage.set("studyId", str);
      this.examReport = false;
    }
    // if (url.indexOf('short=1') != -1) {
    if (url.indexOf("short=1") != -1 && url.indexOf("id=") != -1) {
      let str = url.match(/id=(\S*)&short/)[1];
      Storage.set("makeReportLinkId", str);
      let string = url.indexOf("name=");
      let names = url.substring(string);
      let num = names.indexOf("=");
      let name = names.substring(num + 1);
      Storage.set("makeReportLinkName", decodeURI(name));
    }
    Storage.set("reportPermissions", 2);
    //   this.Montmorillonite = true
    // } else {
    //   this.Montmorillonite = false
    // }

    if (Storage.get("reportPermissions")) {
      this.forwardingReport = false;
    }
    if (Storage.get("code") == 2 && Storage.get("examStatus") == 1) {
      this.examReport = false;
    }
    if (Storage.get("reportPermissions") == 2) {
      this.examReport = false;
    }
    let examId = JSON.parse(Storage.get("reportInfo")).length;
    if (!examId) {
      this.examId = false;
    }
  },
  mounted() {
    let data = Storage.get("studyId");
    let reportInfo = JSON.parse(Storage.get("reportInfo"));
    let baseUrl = "https://mpacsview.pacsonline.cn/#/mobile?studyurl=https%3A%2F%2Fquery.pacsonline.cn%2Fquery%3Faddress%3D&study_id="
    if(this.isAnonymous == 1){
      this.src = baseUrl + data + '&node_type=' + reportInfo[0].node_type + '&anonymous=1';
    }else{
      this.src = baseUrl + data + '&node_type=' + reportInfo[0].node_type;
    }
  }
};
</script>
<style lang="scss" scoped>
.portraitContent {
  padding-top: 55px;
  iframe {
    width: 100%;
    height: calc(100vh - 55px);
  }
}
</style>

